import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../UI/Modal';
import {classNamesPrefixed, camelize} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import { collapsibleSettings } from '../../helpers/Helpers';
import Input from "./Input";
import BtnPrimary from "../UI/BtnPrimary";
import SelectField from "./SelectField";
import CONSTANTS from '../../config/constants.js';
import _ from 'lodash';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

const SortableItem = SortableElement(({value, indexTemp, removeField, editField}) => (
    <li className={classNamesPrefixed({'form-field-item': true})} key={indexTemp}>
        <div className="title">{value.title}</div>
        <div className="action">
        <a className="edit" onClick={() => editField(value, indexTemp)}>Edit</a>
            <a onClick={() => removeField(indexTemp)}>Remove</a>
        </div>
    </li>
));

const SortableList = SortableContainer(({items, removeField, editField}) => {
    return (
      <ul className={classNamesPrefixed({'form-field-list': true})}>
        <li className={classNamesPrefixed({'form-field-list-title': true, 'grey-color': true})}>
            <div className={"title"}>
                <span>{"Fields"}</span>
            </div>
            <div className={"action"}>
                <span>{"Actions"}</span>
            </div>
        </li>
        {items.map((value, index) => (
            <SortableItem 
                key={`item-${index}`}
                index={index}
                indexTemp={index}
                value={value}
                removeField={removeField}
                editField={editField}
            />
        ))}
      </ul>
    );
}); 

class FormStructureField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            formFields: [],
            fieldLabel: '',
            fieldType: '',
            fieldPlaceholder: '',
            fieldTitle: '',
            fieldValidate: [],
            edit: false,
            editIndex: null,
            errorMessage: '',
            submittingMessage: '',
            successMessage: '',
            fieldTitleError: '',
            fieldTypeError: ''
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                formFields: value.formFields,
                errorMessage: value.messages.error,
                submittingMessage: value.messages.submitting,
                successMessage: value.messages.success
            });
        }
    }

    validateTitle() {
        this.setState({
            fieldTitleError: this.state.fieldTitle === '' ? 'This field is required' : ''
        });
    }

    validateType() {
        this.setState({
            fieldTypeError: this.state.fieldType === '' ? 'This field is required' : ''
        });
    }

    validate() {
        this.validateTitle();
        this.validateType();
    }

    save() {
        const {fieldLabel, fieldType, fieldPlaceholder, fieldTitle, fieldValidate, formFields, edit, editIndex} = this.state;

        this.validate();

        if (fieldType !== '' && fieldTitle !== '') {
            let newFormFields = formFields ? formFields : [];
            let camelCaseTitle = camelize(fieldTitle);

            if (edit && editIndex !== null) {
                newFormFields[editIndex].title = fieldTitle;
                newFormFields[editIndex].label = fieldLabel;
                newFormFields[editIndex].type = fieldType;
                newFormFields[editIndex].placeholder = fieldPlaceholder;
                newFormFields[editIndex].name = camelCaseTitle;
                newFormFields[editIndex].id = camelCaseTitle;
                newFormFields[editIndex].validate = fieldValidate;
            } else {
                newFormFields.push(
                    {
                        title: fieldTitle,
                        label: fieldLabel,
                        type: fieldType,
                        placeholder: fieldPlaceholder,
                        name: camelCaseTitle,
                        id: camelCaseTitle,
                        validate: fieldValidate,
                    }
                );
            }

            this.setState({
                formFields: newFormFields,
                modal: false,
                edit: false,
                editIndex: null
            }, () => this.saveData());
        }
    }

    saveData() {
        const {formFields, submittingMessage, successMessage, errorMessage} = this.state;
        
        let data = {};
        data.messages = {
            submitting: submittingMessage, 
            success: successMessage, 
            error: errorMessage
        };
        data.formFields = formFields;

        this.props.input.onChange(data)
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    edit(field, index) {
        this.setState({
            edit: true,
            editIndex: index,
            fieldLabel: field.label,
            fieldType: field.type,
            fieldPlaceholder: field.placeholder,
            fieldTitle: field.title,
            fieldValidate: field.validate,
            fieldTitleError: '',
            fieldTypeError: ''
        }, () => this.showModal());
    }

    remove(index) {
        const {formFields} = this.state;

        let newFormFields = formFields;
        newFormFields.splice(index, 1);

        this.setState({
            formFields: newFormFields
        }, () => this.saveData());
    }

    getDropdownItem(itemId, items) {
        if (itemId) {
            const item = _.find(items, {id: itemId});
            if (item) {
                return {
                    id: item.id,
                    title: item.title
                };
            }
        }
    }

    getDropdownItems(itemIds, items) {
        let dropdownItems = [];
        for(let x in itemIds) {
            dropdownItems.push(this.getDropdownItem(itemIds[x], items));
        }
        return dropdownItems;
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            formFields: arrayMove(this.state.formFields, oldIndex, newIndex),
        }, () => this.saveData());

        document.body.style.cursor = "default";
    };

    onSortStart = () => {
        document.body.style.cursor = "grabbing";
    };

    render() {
        const {modal, formFields, fieldTitle, fieldLabel, fieldType, fieldValidate, fieldPlaceholder, edit, successMessage, errorMessage, submittingMessage, fieldTitleError, fieldTypeError} = this.state;
        const {label, meta: {touched, error}, expanded} = this.props;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={<label className={classNamesPrefixed({"trigger__label":true})}>{label ? label : 'Form Fields'}</label>}
                open={expanded}
            >
                <div className={classNamesPrefixed({"form-strucutre-field-wrap": true})}>
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title={edit ? "Edit" : "Add Field"}
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary 
                                save 
                                icon={"save"}
                                title="Save"
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.save();
                                }}
                            >
                                Save
                            </BtnPrimary>
                        </div>
                    }
                >
                    <div>
                        <Input
                            type="text"
                            id="fieldTitle"
                            name="fieldTitle"
                            value={fieldTitle ? fieldTitle : ""}
                            label="Field Title"
                            required={true}
                            error={fieldTitleError}
                            onChange={(e) => {
                                this.setState({
                                    fieldTitle: e.target.value
                                }, () => this.validateTitle());
                            }}
                        />
                        <SelectField
                            type="select"
                            id="fieldType"
                            name="fieldType"
                            error={fieldTypeError}
                            required={true}
                            defaultValue={this.getDropdownItem(fieldType, CONSTANTS.FORM_FIELD_TYPE_DROPDOWN)}
                            label="Field Type"
                            omitCollapsible={true}
                            items={CONSTANTS.FORM_FIELD_TYPE_DROPDOWN}
                            
                            afterOnChange={(value) => {
                                this.setState({
                                    fieldType: value
                                }, () => this.validateType());
                            }}
                        />
                        <SelectField
                            type="select"
                            id="fieldValidate"
                            name="fieldValidate"
                            defaultValue={this.getDropdownItems(fieldValidate, CONSTANTS.FORM_FIELD_VALIDATE_DROPDOWN)}
                            label="Field Validation"
                            omitCollapsible={true}
                            isMultiple={true}
                            items={CONSTANTS.FORM_FIELD_VALIDATE_DROPDOWN}
                            afterOnChange={(value) => {
                                let newFieldValidate = [];
                                for(let x in value) {
                                    newFieldValidate.push(value[x].id);
                                }
                                this.setState({
                                    fieldValidate: newFieldValidate
                               });
                            }}
                        />
                        <Input
                            type="text"
                            id="fieldLabel"
                            name="fieldLabel"
                            value={fieldLabel ? fieldLabel : ""}
                            label="Field Label"
                            onChange={(e) => {
                                this.setState({
                                    fieldLabel: e.target.value
                                });
                            }}
                        />
                        <Input
                            type="text"
                            id="fieldPlaceholder"
                            name="fieldPlaceholder"
                            value={fieldPlaceholder ? fieldPlaceholder : ""}
                            label="Field Placeholder"
                            onChange={(e) => {
                                this.setState({
                                    fieldPlaceholder: e.target.value
                                });
                            }}
                        />
                     </div>
                </Modal>
                    <Input
                        type="text"
                        id="submittingMessage"
                        name="submittingMessage"
                        value={submittingMessage ? submittingMessage : ""}
                        label="Form submitting message"
                        onChange={(e) => {
                            this.setState({
                                submittingMessage: e.target.value
                            }, () => this.saveData());
                        }}
                    />
                    <Input
                        type="text"
                        id="successMessage"
                        name="successMessage"
                        value={successMessage ? successMessage : ""}
                        label="Form success message"
                        onChange={(e) => {
                            this.setState({
                                successMessage: e.target.value
                            }, () => this.saveData());
                        }}
                    />
                    <Input
                        type="text"
                        id="errorMessage"
                        name="errorMessage"
                        value={errorMessage ? errorMessage : ""}
                        label="Error Message"
                        onChange={(e) => {
                            this.setState({
                                errorMessage: e.target.value
                            }, () => this.saveData());
                        }}
                    />
                    <div>
                        <ul
                            className={classNamesPrefixed({
                                'default-list': true
                            })}
                        >
                            {formFields.length > 0 ? (
                                <SortableList 
                                    items={formFields}
                                    onSortEnd={this.onSortEnd}
                                    removeField={this.remove.bind(this)}
                                    editField={this.edit.bind(this)}
                                    helperClass={"active"}
                                />
                            ) : (
                                <div><i>Currently form has no fields, press "Add Field" to add new field.</i></div>
                            )
                            }
                        </ul>
                    </div>
                    <div
                        className={classNamesPrefixed({
                            'form-actions': true
                        })}
                    >
                        <BtnPrimary 
                            small
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    fieldLabel: '',
                                    fieldType: '',
                                    fieldPlaceholder: '',
                                    fieldTitle: '',
                                    fieldValidate: [],
                                    fieldTitleError: '',
                                    fieldTypeError: '',
                                    edit: false
                                }, () => this.showModal());
                            }}
                        >
                            Add Field
                        </BtnPrimary>
                    </div>
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
                </div>
            </Collapsible>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStructureField)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/FormStructureField.js